import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMode } from '../actions/modeAction';
const DarkModeButton = () => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.dark.data);
  return (
    <div className='toggle-theme-wrapper'>
      <span>☀️</span>
      <label className='toggle-theme' htmlFor='checkbox'>
        <input
          type='checkbox'
          id='checkbox'
          checked={dark}
          onChange={() => {
            dispatch(toggleMode(!dark));
          }}
        />
        <div className='slider round'></div>
      </label>
      <span>🌒</span>
    </div>
  );
};

export default DarkModeButton;
